import { createApi } from '@reduxjs/toolkit/query/react';
import { environment } from '@energy-stacks/feature-config';
import { createBaseQuery } from '@energy-stacks/shared';

export const preferencesApi = createApi({
  reducerPath: 'settingsApi',
  baseQuery: createBaseQuery(`${environment.ocppServiceUrl}`),
  tagTypes: ['apiKey', 'logo', 'favIcon', 'uiBranding'],
  endpoints: (builder) => ({
    setLogo: builder.mutation<void, File>({
      query: (logoFile) => {
        const formData = new FormData();
        formData.append('logo', logoFile);

        return {
          url: `/ui-configuration/logo`,
          method: 'PUT',
          body: formData,
        };
      },
      invalidatesTags: ['logo'],
    }),
    setFavicon: builder.mutation<void, File>({
      query: (faviconFile) => {
        const formData = new FormData();
        formData.append('favIcon', faviconFile);

        return {
          url: `/settings/favicon.ico`,
          method: 'PUT',
          body: formData,
        };
      },
      invalidatesTags: ['favIcon'],
    }),
  }),
});

export const { useSetLogoMutation, useSetFaviconMutation } = preferencesApi;
